'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthPoliciesListPage, SETTINGS_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/')({
  component: () => <AuthPoliciesListPage paths={SETTINGS_AUTH_POLICY_PATHS} />
});